import { MenuItem, Divider, Menu } from "@mui/material";
import { memo } from "react";
import { normalizeDishSequence } from "../../../../service/BuyerConfiguration/DishManagement/dishService";
import {
  notifySuccess,
  notifyError,
} from "../../../../components/ToastContainer/Toast/Toast";

type PropsDishSequenceMenu = {
  open: boolean;
  onClose: () => void;
  fetchDishes: () => Promise<void>;
  setOpenSequenceMenu: (open: boolean) => void;
  anchorEl: HTMLElement | null;
  rows: any[];
};

const DishSequenceMenu: React.FC<PropsDishSequenceMenu> = ({
  open,
  onClose,
  fetchDishes,
  setOpenSequenceMenu,
  anchorEl,
  rows,
}) => {
  const handleNormalizeSequence = async (foodType: string) => {
    try {
      const response = await normalizeDishSequence(foodType);
      if (response?.statusCode === 200 || response?.statusCode === 201) {
        notifySuccess(
          response?.data?.message || "Dish sequence normalized successfully"
        );
      } else {
        notifyError("Failed to normalize sequence");
      }
    } catch (error: any) {
      notifyError(error?.response?.data?.message || "Something went wrong!");
    } finally {
      fetchDishes();
      setOpenSequenceMenu(false);
    }
  };

  return (
    <Menu
      id="dish-sequence-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 3,
        sx: {
          overflow: "visible",
          mt: 1,
          "&::before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
          },
        },
      }}
    >
      {rows.length > 0 &&
        ["Veg", "Non-Veg", "Pure-Veg"].map((foodType: string) => (
          <>
            <MenuItem
              sx={{
                width: "100%",
                maxWidth: "150px",
                textAlign: "center",
              }}
              key={foodType}
              onClick={() => handleNormalizeSequence(foodType)}
            >
              {foodType}
            </MenuItem>
            <Divider />
          </>
        ))}
    </Menu>
  );
};

export default memo(DishSequenceMenu);
